
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Images from "../../Constants/Images";
import website from '../../Assets/Imgas/Home/website.mp4';
const OwnRentals = () => {
    const [isUserInteracted, setIsUserInteracted] = useState(false);
    const videoRef = useRef(null);
    const { i18n } = useTranslation();
    const currentLanguageCode = i18n.language;
    const handleIntersection = (entries) => {
        entries.forEach(entry => {
            if (videoRef.current) {
                if (entry.isIntersecting) {
                    if (isUserInteracted) {
                        videoRef.current.muted = false;
                        videoRef.current.play().catch(err => {
                            console.error('Play failed:', err);
                        });
                    }
                } else {
                    videoRef.current.muted = true;
                    videoRef.current.pause();
                }
            }
        });
    };

    useEffect(() => {
        const observer = new IntersectionObserver(handleIntersection, {
            threshold: 0.5
        });

        if (videoRef.current) {
            observer.observe(videoRef.current);
        }

        return () => {
            if (videoRef.current) {
                observer.unobserve(videoRef.current);
            }
        };
    }, [isUserInteracted]);

    const handleUserInteraction = () => {
        setIsUserInteracted(true);
    };

    useEffect(() => {
        window.addEventListener('click', handleUserInteraction);
        return () => {
            window.removeEventListener('click', handleUserInteraction);
        };
    }, []);

    return (
        <div className="relative flex items-center w-full h-[100vh] min-h-[600px] max-[1020px]:h-[70vh] max-[1020px]:min-h-[500px] max-[600px]:h-[50vh] max-[600px]:min-h-[400px] Own_Rentals">
            <div className="Vidoebanner absolute object-cover z-20 w-full h-[100vh] min-h-[600px] max-[1020px]:h-[70vh] max-[1020px]:min-h-[500px] max-[600px]:h-[50vh] max-[600px]:min-h-[400px]">
                <div className="w-full h-full absolute bg-[rgba(0,0,0,0.5)] z-10"></div>
                {currentLanguageCode === "fr" ?
                    <video
                        ref={videoRef}
                        autoPlay
                        loop
                        muted={false}
                        playsInline
                        controls={false}
                        className="absolute object-cover object-top w-full h-[100vh] min-h-[600px] max-[1020px]:h-[70vh] max-[1020px]:min-h-[500px] max-[600px]:h-[50vh] max-[600px]:min-h-[400px]"
                    >
                        <source src={website} type="video/mp4" />
                    </video> :
                    <video
                        ref={videoRef}
                        autoPlay
                        loop
                        muted={false}
                        playsInline
                        controls={false}
                        className="absolute object-cover object-top w-full h-[100vh] min-h-[600px] max-[1020px]:h-[70vh] max-[1020px]:min-h-[500px] max-[600px]:h-[50vh] max-[600px]:min-h-[400px]"
                    >
                        <source src={Images.KozeEnglish} type="video/mp4" />
                    </video>
                }

            </div>
            <div className="relative grid grid-cols-2 max-[600px]:flex max-[600px]:gap-4 container z-20">
            </div>
        </div>
    );
};

export default OwnRentals;
